import React, { useEffect, useState } from 'react';
import AuditLogRow from './AuditLogRow';
import ShareWithRow from './ShareWithRow';
import ViewHistoryRow from './ViewHistoryRow';

interface IActivityTabProps {
  cur_case: any;
  handleTabSwitch: any;
  setShareModal: any;
  owner: string;
}

const ActivityComponent: React.FC<IActivityTabProps> = ({ cur_case, handleTabSwitch, setShareModal, owner }) => {
  const [ currentItems, setCurrentItems ] = useState<any[]>([]);
  const [ currentPage, setCurrentPage ] = useState(1);
  const [ currentPageSharedWith, setCurrentPageSharedWith ] = useState(1);
  const [ sharedWithUsers, setSharedWithUsers ] = useState<any[]>([]);

  const verisonsArr = cur_case.data.results;
  const sharedArr = cur_case.data.sharedWith;
  const activities = cur_case.data.activity;
  const itemsPerPage = 5;
  const usersPerPage = 4;
  const totalPages = Math.max(1, Math.ceil(cur_case.data.activity?.length / itemsPerPage));
  const totalPagesSharedWith = Math.max(1, Math.ceil(cur_case.data.sharedWith?.length / usersPerPage));

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, Math.ceil(activities?.length / itemsPerPage)));
  };
  const handleNextPageSharedWith = () => {
    if (sharedArr?.length > 4){
      setCurrentPageSharedWith((prevPage) => Math.min(prevPage + 1, Math.ceil(sharedArr?.length / usersPerPage)));
    }
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };
  const handlePrevPageSharedWith = () => {
    setCurrentPageSharedWith((prevPage) => Math.max(prevPage - 1, 1));
  };


  useEffect(() => {
    if (activities.length) {
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      setCurrentItems(activities.slice(indexOfFirstItem, indexOfLastItem));
    }
  }, [ currentPage, activities ]);

  useEffect(() => {
    if (sharedArr.length) {
      const indexOfLastItem = currentPageSharedWith * usersPerPage;
      const indexOfFirstItem = indexOfLastItem - usersPerPage;
      setSharedWithUsers(sharedArr.slice(indexOfFirstItem, indexOfLastItem));
    }
  }, [ currentPageSharedWith, sharedArr ]);

  return (
    <>
      <div className='activity-cont-frame'>
        <div className='activity-cont-frame-left' style={{ height: '470px' }}>
          <div className='audit-modal-cont-head'>
            <div className='audit-modal-cont-head-content'>
              <div className='audit-modal-cont-head-content-text'>
                <h1>Version History</h1>
              </div>
            </div>
          </div>
          <div className='view-history-head-frame'>
            <div className='view-history-head-frame-cell'>
              <div className='view-history-head-frame-cell-cont'>
                <div className='view-history-head-frame-cell-cont-text'>
                   Date Screened
                </div>
              </div>
            </div>
            <div className='view-history-head-frame-cell'>
              <div className='view-history-head-frame-cell-cont'>
                <div className='view-history-head-frame-cell-cont-text'>
              Total Results
                </div>
              </div>
            </div>
            <div className='view-history-head-frame-cell'>
              <div className='view-history-head-frame-cell-cont'>
                <div className='view-history-head-frame-cell-cont-text'>
              Results Added
                </div>
              </div>
            </div>
            <div className='view-history-head-frame-cell-empty'></div>
          </div>
          <div className='view-history-body-frame' style={{ maxHeight: '275px', height: '200px !important' }}>
            {verisonsArr.map((ver: any) => (
              <React.Fragment key={ver._id}>
                <ViewHistoryRow
                  version={ver}
                  handleTabSwitch={handleTabSwitch} />
              </React.Fragment>
            ))}

          </div>
          <div className='monitor-results-footer'>

          </div>
        </div>
        <div className='activity-cont-frame-right'>
          <div className='activity-cont-frame-left-table'>
            <div className='activity-cont-frame-left-table-cont'>
              <div className='activity-cont-frame-left-table-cont-text-sup'>
                <div className='activity-cont-frame-left-table-cont-text-sup-bagde'>
                  <div className='activity-cont-frame-left-table-cont-text-sup-bagde-frame'>
                    <div>Shared with <div className='activity-cont-frame-left-table-cont-text-sup-bagde-btn' onClick={() => setShareModal(true)}>+ Share ticket</div></div>
                  </div>
                </div>
              </div>
            </div>
            <div className='activity-cont-frame-left-table-feed' style={{ paddingTop: '15px', gap: 'var(--spacing-lg, 15px)' }}>
              <ShareWithRow member={owner} perms={'Owner'} />
              <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
              {sharedWithUsers.map((member: string, i: number) => (
                <>
                  <ShareWithRow key={i} member={member} perms={'Contributer'} />
                  <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
                </>
              ))}
            </div>
            <div className='activity-cont-frame-pagination'>
              <div className='activity-cont-frame-pagination-text'>Page {currentPageSharedWith} of { totalPagesSharedWith }</div>
              <div className='activity-cont-frame-pagination-action'>
                <div className='activity-cont-frame-pagination-action-prev'>
                  <div className='activity-cont-frame-pagination-action-text' onClick={handlePrevPageSharedWith}>Previous</div>
                </div>
                <div className='activity-cont-frame-pagination-action-prev'>
                  <div className='activity-cont-frame-pagination-action-text' onClick={handleNextPageSharedWith}>Next</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='activity-cont-frame-right' style={{ paddingTop: '20px', marginBottom: '30px' }}>
        <div className='activity-cont-frame-left-table'>
          <div className='activity-cont-frame-left-table-cont'>
            <div className='activity-cont-frame-left-table-cont-text-sup'>
              <div className='activity-cont-frame-left-table-cont-text-sup-bagde'>
                <div className='activity-cont-frame-left-table-cont-text-sup-bagde-frame'>
                  <div>Audit Log</div>
                </div>
              </div>
            </div>
          </div>
          <div className='audit-doc-tabe-col'>
            <div className='audit-doc-tabe-col-right-cell'>
              <div>
                <div className='audit-doc-tabe-col-left-cell-text'>User</div>
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                  <path d='M7.99992 3.33301V12.6663M7.99992 12.6663L12.6666 7.99967M7.99992 12.6663L3.33325 7.99967' stroke='#F5FAFF' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
              </div>
            </div>
            <div className='audit-doc-tabe-col-right-cell'>
              <div>
                <div className='audit-doc-tabe-col-left-cell-text'>Action</div>
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                  <path d='M7.99992 3.33301V12.6663M7.99992 12.6663L12.6666 7.99967M7.99992 12.6663L3.33325 7.99967' stroke='#F5FAFF' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
              </div>
            </div>
            <div className='audit-doc-tabe-col-right-cell'>
              <div>
                <div className='audit-doc-tabe-col-left-cell-text'>Date & Time</div>
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                  <path d='M7.99992 3.33301V12.6663M7.99992 12.6663L12.6666 7.99967M7.99992 12.6663L3.33325 7.99967' stroke='#F5FAFF' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
              </div>
            </div>
          </div>
          <div className='activity-cont-frame-left-table-feed' style={{ paddingTop: '15px', gap: 'var(--spacing-lg, 15px)' }}>
            { currentItems?.map((activity: any) => (
              <>
                <AuditLogRow activity={activity}/>
                <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
              </>
            ))}
          </div>
          <div className='activity-cont-frame-pagination'>
            <div className='activity-cont-frame-pagination-text'>
              Page {currentPage} of {totalPages}
            </div>
            <div className='activity-cont-frame-pagination-action'>
              <div className='activity-cont-frame-pagination-action-prev'>
                <div className='activity-cont-frame-pagination-action-text' onClick={handlePrevPage}>
                  Previous
                </div>
              </div>
              <div className='activity-cont-frame-pagination-action-prev'>
                <div className='activity-cont-frame-pagination-action-text' onClick={handleNextPage}>
                  Next
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivityComponent;
